import { ConcatenateDialog } from "@components/concatenate/ConcatenateDialog";
import { FastaSizeWarningDialog } from "@components/import-review/FastaSizeWarningDialog";
import { ImportReviewDialog } from "@components/import-review/ImportReviewDialog";
import { CommandPalette } from "@components/layout/CommandPalette";
import { SmallScreenMessage } from "@components/SmallScreenMessage";
import { SequenceCreate } from "@components/sequence-create";
import { useSequenceCreateStore } from "@components/sequence-create/sequenceCreateStore";

import { useIsMobile } from "@hooks/use-mobile";
import { useWarnBeforeUnload } from "@hooks/useWarnBeforeUnload";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "@ui/sonner";
import { resumeIncompleteImports } from "@upload/upload";
import { lazy, Suspense, useEffect } from "react";

const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import("@tanstack/react-router-devtools").then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    );

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const isMobile = useIsMobile();
  const { open, mode, closeDialog } = useSequenceCreateStore();

  useWarnBeforeUnload();

  useEffect(() => {
    resumeIncompleteImports();
  }, []);

  if (isMobile) {
    return <SmallScreenMessage />;
  }

  return (
    <>
      <CommandPalette />
      <ConcatenateDialog />
      <FastaSizeWarningDialog />
      <ImportReviewDialog />
      <SequenceCreate
        open={open}
        initialMode={mode}
        onOpenChange={(open) => {
          if (!open) closeDialog();
        }}
      />
      <div className="flex h-screen">
        <Outlet />
      </div>
      <Toaster />
      <Suspense fallback={null}>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  );
}
